import type { DateTime } from 'luxon'

export default function normalizeBirthday(birthday: DateTime): DateTime {
  return birthday.startOf('month').set({ day: 15 })
}
